import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {EventsComponent} from "./events.component";
import {EventDetailComponent} from "./eventdetail/event-detail.component";
import {CreateeventComponent} from "./createevent/createevent.component";
import {AuthGuardTsGuard} from "../../guard/auth-guard.ts.guard";
import {EditEventComponent} from "../../shared/components/event/edit-event/edit-event.component";
import {MainlayoutComponent} from "../../shared/components/layout/mainlayout/mainlayout.component";

const routes: Routes = [
  {
    path: '', component: MainlayoutComponent, children: [
      {path: 'criar', component: CreateeventComponent, canActivate: [AuthGuardTsGuard]},
      {path: 'ocorrencias', component: EventsComponent},
      {path: 'ocorrencia/:slug', component: EventDetailComponent},
      {path: 'ocorrencia/:slug/editar', component: EditEventComponent, canActivate: [AuthGuardTsGuard]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventRoutingModule {
}
